import { useRef, useState } from 'react';


const AudioPlayer = ({ src }: { src: string }) => {
    const audioRef = useRef<any>(null);
    const [isAudioPlaying, setIsAudioPlaying] = useState<boolean>(false);

    const playAudio = () => {
        if (audioRef && audioRef.current) {
            audioRef.current.play();
            setIsAudioPlaying(true);
        }
    };

    const pauseAudio = () => {
        if (audioRef && audioRef.current) {
            audioRef.current.pause();
            setIsAudioPlaying(false);
        }
    };

    const handleEnded = () => {
        setIsAudioPlaying(false);
    };

    return (
        <div title='Info Audio' style={{color: "black" ,background: "none", border: "none" }}>
            <audio ref={audioRef} src={src} onEnded={handleEnded}
            />
            {!isAudioPlaying && <span onClick={playAudio} className="mdi mdi-play-circle  fs-5"></span>}
            {isAudioPlaying && <span onClick={pauseAudio} className="mdi mdi-pause-circle fs-5"></span>}

        </div>
    );
};

export default AudioPlayer;